import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { API } from "../../utils/Apis";
import { SpaceTypes } from "../../Constants/Interfaces";
import { defaultAvailability } from "../../Constants";
import { convertToMinutes, getTimeFrame, showToast } from "../../utils/helpers";

type bookingItem = {
  id: string;
  type: string;
  startDate: string | undefined;
  startTime: string;
  endDate: string | undefined;
  endTime: string;
};

interface ReScheduleBookingType {
  show: boolean;
  item: bookingItem;
  closeModal: Function;
  updateItem: Function;
}

const ReScheduleBooking: React.FC<ReScheduleBookingType> = ({
  show,
  item,
  closeModal,
  updateItem,
}) => {
  const [data, setData] = useState({
    bookingId: "",
    newDay: "",
    newStartDate: "",
    newStartTime: "",
    newEndDate: "",
    newEndTime: "",
    timeFrame: "",
  });

  const [loading, setLoading] = useState(false);
  const [bookingItem, setBookingItem] = useState<bookingItem | undefined>();
  const [spaceItem, setSpaceItem] = useState<SpaceTypes | undefined>();

  const [disabledDates, setBookedDates] = useState([]);

  const onChange = (field: string, value: string) => {
    setData({ ...data, [field]: value });
  };

  const updateBooking = () => {
    if (!loading) {
      setLoading(true);
      API.timeChangeRequest(data)
        .then((res) => {
          console.log("RES :", res);

          if (res.type === "success") {
            closeModal();

            updateItem({
              startDate: res.data.startDate,
              startTime: res.data.startTime,
              endDate: res.data.endDate,
              endTime: res.data.endTime,
            });
          }

          showToast(res.type, res.message);
        })
        .catch((err) => {
          showToast("error", err.message);
          console.log("ERR :", err);
        })
        .finally(() => setLoading(false));
    }
  };

  const getBookedDates = useCallback(
    (timeFrame: string) => {
      if (bookingItem) {
        const duration = convertToMinutes(timeFrame);

        const filters = {
          type: bookingItem.type,
          duration,
        };

        API.getUnavailableDate(bookingItem.id, filters)
          .then((res) => {
            if (res.type === "success") {
              setBookedDates(res.bookedDates);
            }
          })
          .catch((err) => {
            console.log("ERR:", err);
          });
      }
    },
    [bookingItem]
  );

  const getSingleBooking = (id: string) => {
    API.getBookingDetails(id)
      .then((res) => {
        console.log("BookingITEM :", res.data);

        if (res.type === "success") {
          setBookingItem(res.data);
        }
      })
      .catch((err) => {
        console.log("ERR :", err);
      });
  };

  const getSpaceItem = (id: string) => {
    API.getSpace(id)
      .then((res) => {
        console.log("SpaceITEM :", res.data);

        if (res.type === "success") {
          setSpaceItem(res.data);
        }
      })
      .catch((err) => {
        console.log("ERR :", err);
      });
  };

  const updateEndDate = useCallback(() => {
    const startDateT = moment(`${data.newStartDate} ${data.newStartTime}`);

    const temp = String(data.timeFrame).split(" ");
    const endDate = startDateT.add(temp[0], temp[1]);

    setData({
      ...data,
      day: moment(data.newStartDate).format("ddd"),
      newEndDate: endDate.format("YYYY-MM-DD"),
      newEndTime: endDate.format("HH:mm"),
    });
  }, [data]);

  useEffect(updateEndDate, [data.newStartDate, data.newStartTime]);

  useEffect(() => {
    if (
      bookingItem &&
      bookingItem.startDate &&
      bookingItem.startTime &&
      bookingItem.endDate &&
      bookingItem.endTime
    ) {
      const timeFrame = getTimeFrame(
        bookingItem.startDate,
        bookingItem.startTime,
        bookingItem.endDate,
        bookingItem.endTime
      );

      setData({
        ...data,
        bookingId: bookingItem.id,
        newDay: moment(bookingItem.startDate).format("ddd"),
        newStartDate: bookingItem.startDate,
        newStartTime: bookingItem.startTime,
        newEndDate: bookingItem.endDate,
        newEndTime: bookingItem.endTime,
        timeFrame: timeFrame,
      });
    }
  }, [bookingItem]);

  useEffect(() => {
    getSingleBooking(item.id);
    getBookedDates();
    if (item && item.space) {
      getSpaceItem(item.space.id);
    }
  }, []);

  return (
    <Modal show={show} onHide={() => closeModal()}>
      <Modal.Header closeButton>Update Boooking</Modal.Header>
      <Modal.Body>
        <Row>
          <Col>
            <div className="form-group">
              <div className="form-label">Start Date</div>
              <DatePicker
                showIcon
                icon="far fa-calendar"
                value={
                  data && data.newStartDate ? data.newStartDate : new Date()
                }
                selected={data && data.newStartDate ? data.newStartDate : ""}
                minDate={new Date()}
                className="form-control"
                placeholderText="MM/DD/YYYY"
                onChange={(date: Date | undefined) => {
                  const newDate = moment(date).format("YYYY-MM-DD");
                  onChange("newStartDate", newDate);
                }}
                filterDate={(date) => {
                  const day = date.getDay();
                  const workingDays = (spaceItem && spaceItem.days) || [];
                  const indexes = defaultAvailability.reduce((acc, item, i) => {
                    if (!workingDays.includes(item.day)) acc.push(i);
                    return acc;
                  }, [] as number[]);
                  return !indexes.includes(day); // Disable Sunday & Saturday
                }}
                excludeDates={disabledDates}
              />
            </div>
          </Col>
          <Col>
            <div className="form-group">
              <div className="form-label">End Time</div>
              <input
                type="time"
                name="startDate"
                placeholder="Select Time"
                className="form-control"
                value={data.newStartTime}
                onChange={(e) => onChange("newStartTime", e.target.value)}
              />
            </div>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer className="justify-content-start">
        <Button onClick={() => updateBooking()}>
          {loading && <i className="fas fa-spinner fa-spin" />}
          {!loading && "Update"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReScheduleBooking;
